var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: { "is-showing": _vm.isShowing },
      on: { "close-modal": _vm.closeModal },
    },
    [
      _c(
        "div",
        {
          staticStyle: { padding: "56.25% 0 0 0", position: "relative" },
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("iframe", {
            staticStyle: {
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
            },
            attrs: {
              src: _vm.videoUrl,
              frameborder: "0",
              allow: "autoplay; fullscreen; picture-in-picture",
              allowfullscreen: "",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }